import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { LoadingScreen } from "../../components/ui/LoadingScreen";
import { useAuth } from "../../contexts/AuthContext";
import { signInPathForDestination } from "../../lib/authRedirect";

export const TOPCLIP_AUTO_ROUTE_PATHS = Object.freeze({
  create: "/create-clips",
  job: "/create-clips/:jobId",
  legacyDevCreate: "/dev/create-clips",
  legacyDevJob: "/dev/create-clips/:jobId",
  legacyAiCreate: "/create-clips-ai",
});

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, isSigningOut } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen />;
  }

  if (isSigningOut) {
    return <Navigate replace to="/" />;
  }

  if (!user) {
    return (
      <Navigate
        replace
        to={signInPathForDestination(location.pathname)}
      />
    );
  }

  return <>{children}</>;
};

export const LegacyCreateJobRedirect: React.FC = () => {
  const { jobId } = useParams<{ jobId: string }>();
  return (
    <Navigate
      replace
      to={jobId ? `/create-clips/${encodeURIComponent(jobId)}` : TOPCLIP_AUTO_ROUTE_PATHS.create}
    />
  );
};
